<template>
  <div v-if="dataLoaded && staticDataLoaded">
    <div :class="{ 'ret-alarms-panel': isDesktop }">
      <v-card>

        <asset-detail v-if="selectedElement"
                      :visualMode="visualMode"
                      :selected-element="selectedElement"
                      :selected-element-asset-route="selectedElementAssetRoute"
                      @deselect-asset="$emit('deselect-asset')"/>

        <v-divider v-if="selectedElement"/>

        <v-card-title v-if="title">
          <h4>{{ $t('alarms') }}</h4>
        </v-card-title>

        <alarms-panel v-if="filteredItems.length"
                :items="filteredItems"
                :asset-tree="assetTree"
                @select-asset="$emit('select-asset', $event)"
                @map="$router.push({ name: 'city-map', params: { assetId: $event }})"/>

        <v-subheader v-else>
          <v-icon>check_circle</v-icon>
          <span class="ml-2">{{ $t('no-alarms') }}</span>
        </v-subheader>

      </v-card>
    </div>
  </div>
</template>

<style scoped>
  .ret-alarms-panel {
    position: fixed;
    top: 30vh;
    right: 10px;
    min-height: 103px;
    max-height: 65vh;
    width: 25em;
    overflow-y: auto;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    opacity: 0.8;
  }
</style>

<script>
import itemsHelpers from '../helpers/items-helpers.es6'
import AssetDetail from './asset-detail.vue'
import AlarmsPanel from './alarms-panel.vue'

const sortSeverity = {
  'info': 0,
  'warning': 1,
  'error': 2
}

const alarmsSort = (a, b) => {
  const severityA = sortSeverity[a.severity]
  const severityB = sortSeverity[b.severity]
  // sort by time, then severity, descending
  if (a.detectedAt < b.detectedAt) {
    return -1
  }
  if (a.detectedAt > b.detectedAt) {
    return 1
  }
  if (severityA < severityB) {
    return 1
  }
  if (severityA > severityB) {
    return -1
  }
  return 0
}

export default {
  mixins: [itemsHelpers],
  components: {
    AssetDetail,
    AlarmsPanel
  },
  props: {
    selectedElement: {
      type: Object
    },
    selectedElementAssetRoute: {
      type: String
    },
    title: {
      default: true
    },
    visualMode: {
      type: String
    }
  },
  data () {
    return {
      model: {
        name: 'alarms'
      },
      assetTree: null,
      staticDataLoaded: false,
      filteredItems: []
    }
  },
  computed: {
    assetData () {
      return this.$store.state.assetData
    },
    isDesktop () {
      return this.$store.state.userAgent.isDesktop
    },
    sortedItems () {
      const items = this.items ? [...this.items] : []
      return items.sort(alarmsSort)
    }
  },
  watch: {
    selectedElement () {
      // reset to empty and $nextTick required to prevent animations when switching between elements with alarms
      this.filteredItems = []
      this.$nextTick(() => {
        this.updateFilteredItems()
      })
    },
    sortedItems: {
      handler () {
        this.updateFilteredItems()
      },
      deep: true
    }
  },
  methods: {
    beforeDataLoaded () {
      this.$store.dispatch('getStaticItems', { model: { name: 'assets', tree: true } })
        .then(() => {
          this.assetTree = this.$store.state.staticItems['assets']
          this.staticDataLoaded = true
        })
    },
    updateFilteredItems () {
      this.filteredItems = this.sortedItems
        .filter(({ assetId }) => !this.selectedElement || (assetId === this.selectedElement.assetId))

      this.$emit('items-changed', this.filteredItems)
    }
  }
}
</script>
